import React from 'react';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';
import { siteConfig } from '../data/mockData';

const CTA = ({ onBookNow }) => {
  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url('https://images.pexels.com/photos/10213239/pexels-photo-10213239.jpeg?w=1920&h=600&fit=crop')`,
        }}
      >
        <div className="absolute inset-0 bg-[#22C55E]/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
          Ready For Your Dump Trailer?
        </h2>
        <p className="text-white/90 text-lg mb-10 max-w-2xl mx-auto">
          Book your dump trailer today and experience the Dump Trailer Dude difference. 
          Serving all of Central Wisconsin with fast, reliable trailer service.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button 
            size="lg"
            onClick={onBookNow}
            className="bg-white hover:bg-gray-100 text-[#22C55E] px-10 py-6 text-lg font-semibold rounded-md transition-all duration-300 hover:scale-105 shadow-lg"
          >
            Book Now
          </Button>
          
          <a 
            href={`tel:${siteConfig.phone}`}
            className="flex items-center space-x-2 text-white hover:text-white/80 transition-colors text-lg font-semibold"
          >
            <Phone className="w-6 h-6" />
            <span>{siteConfig.phoneFormatted}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
